import { render } from "./Fp_introduction.vue?vue&type=template&id=bf0c7922&scoped=true"
const script = {}

import "./Fp_introduction.vue?vue&type=style&index=0&id=bf0c7922&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0c7922"]])

export default __exports__